export const LEGACY_ALERT_RETIREMENT_KEY = 'valentine:legacy-alerts-retired';

export function rememberLegacyAlertRetirement(): void {
  try {
    localStorage.setItem(LEGACY_ALERT_RETIREMENT_KEY, '1');
  } catch {
    // This is a presentation hint only; committed logout/reset stays successful.
  }
}

export function hasLegacyAlertRetirement(): boolean {
  try {
    return localStorage.getItem(LEGACY_ALERT_RETIREMENT_KEY) === '1';
  } catch {
    return false;
  }
}

export function clearLegacyAlertRetirement(): void {
  try {
    localStorage.removeItem(LEGACY_ALERT_RETIREMENT_KEY);
  } catch {
    // If removal is blocked, retaining the warning for a later visit is safer.
  }
}

export function consumeLegacyAlertRetirement(): boolean {
  const present = hasLegacyAlertRetirement();
  if (present) clearLegacyAlertRetirement();
  return present;
}
